export default {
    path: 'extra',
    component: () => import('../Extra.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Extra',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo Extra',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa Extra',
            component: () => import('../cu/CU.vue'),
        },
    ]
};